<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        :title='item.data === undefined ? "负责人添加" : "负责人编辑" '
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='400'
      >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <!-- <v-row>
              <v-col cols="12">
                <v-user-select :show-user='2' outlined hide-details='auto' :rules="array" label="协同人选择" v-model='form.assistPersonList'></v-user-select>
              </v-col>
            </v-row> -->
             <v-row>
              <v-col cols="12">
                <v-user-select :show-user='2' outlined label="抄送人选择" v-model='form.copyPersonsList'></v-user-select>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { isEmpty } from '@/utils/stringUtil.js'
  import { save } from '@/api/order/index.js'
  import VUserSelect from '@/components/select/v-user-select.vue'

  export default {
    name: 'OrderPersionEdit',
    components: {
      VUserSelect
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        array: [
          value => value.length > 0 || '此项为必填项!'
        ],
        form: {
          id: '',
          copyPersons: '',
          copyPersonsList: []
        }
      }
    },
    methods: {
      save () {
        this.builSubForm()
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
       builSubForm () {
        this.form.copyPersons = JSON.stringify(this.form.copyPersonsList)
      },
      dialogChange (val) {
        this.reset()
        this.item.show = val
        if (val && this.isEdit) {
          this.form = JSON.parse(JSON.stringify(this.item.data))
        }
      },
      reset () {
        if (!isEmpty(this.$refs.form)) {
          this.$refs.form.reset()
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
